// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `in-button {
  margin-left: 0.5em;
}

.hide {
  display: none;
}

.o-panel-container_sidepanel.fullheight {
  max-height: calc(140vh - 10px);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
